import { Heading, Box } from 'grommet'
import styled from 'styled-components'

export const DescriptionContainer = styled(Box)`
  align-items: center;
  text-align: center;
  width: 100%;
`

export const DescriptionTitle = styled(Heading)`
  align-self: ${({ titlePosition }) => titlePosition || 'normal'};
  color: ${({ theme }) => theme.newColors.primary};
  font-size: ${({ theme }) => theme.fontSizes[12]}px;
  font-weight: ${({ theme }) => theme.fontWeight[7]};
  line-height: ${({ theme }) => theme.lineHeight[3]}px;
  margin-bottom: ${({ theme }) => theme.newSpaces.lg}px;
  max-width: ${({ width }) => width || '100%'};
  text-align: ${({ titleAlign }) => titleAlign || 'center'};
  text-transform: ${({ textTransform }) => textTransform || 'none'};
  white-space: pre-wrap;
  word-wrap: break-word;

  ${({ theme }) => theme.below.tablet`
    margin-bottom: ${theme.newSpaces.xs}px;
  `}

  ${({ theme }) => theme.below.laptop`
    padding: ${theme.spaces[0]}px;
  `}

  ${({ theme }) => theme.below.mobileXL`
    ${theme.getTypography('mobile', 'title', 'title1')}
    margin-bottom: ${theme.newSpaces.xs}px;
  `}

  ${({ theme }) => theme.below.mobileS`
    line-height: ${theme.lineHeight[0]}px;
  `}

  ${({ theme }) => theme.below.tablet`
    text-transform: capitalize;
    text-align: center;
  `}
`

export const DescriptionSubtitle = styled.p`
  align-self: ${({ textPosition }) => textPosition};
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: ${({ theme }) => theme.fontSizes[4]}px;
  font-weight: ${({ theme }) => theme.fontWeight[2]};
  line-height: ${({ theme }) => theme.lineHeight[5]}px;
  margin-bottom: ${({ theme }) => theme.newSpaces.lg}px;
  max-width: ${({ theme }) => theme.maxWidth[4]}px;
  padding: 0 ${({ padding }) => padding};
  text-align: ${({ textAlign }) => textAlign};
  word-wrap: break-word;

  ${({ theme }) => theme.below.tablet`
    margin-bottom: ${theme.newSpaces.sm}px;
  `}

  & > a {
    color: ${({ theme }) => theme.colors.primary};

    ${({ theme }) => theme.below.mobileXL`
      ${theme.getTypography('mobile', 'body', 'body2')}
    `}
  }

  ${({ theme }) => theme.below.laptop`
    padding: 0;
  `}

  ${({ theme }) => theme.below.tablet`
    ${theme.getTypography('mobile', 'body', 'body2')}

    width: 100% !important;
    text-align: center;
    margin-bottom: ${theme.newSpaces.sm}px;

    & > a {
      ${theme.getTypography('mobile', 'body', 'body2')}
    }
  `}
`
